module.exports = __webpack_public_path__ + "img/instagram-white.142a51bf.svg";